<template>
  <v-btn
    class="btn-reg"
    color="#992656b8"
    dark
    :to="{name: 'registration'}"
    @click="$emit('click')"
    elevation="0"
  >{{ title ? title : $t('msg.registration') }}</v-btn>
</template>

<script>
export default {
  props: {
    title: {type: String, default: null}
  },
}
</script>

<style lang="scss">
.btn-reg {
  height: 50px !important;
  padding-left: 50px !important;
  padding-right: 50px !important;

  .v-btn__content {
    font-size: 16px;
    font-weight: 300;
  }
}
</style>